import { ShieldCheck } from "lucide-react";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Stagger, Item } from "@/components/shared/Reveal";

const CERTS = [
  { name: "SecurePath", body: "SIRA SecurePath registered — approved vehicle tracking provider", src: "/certs/securepath.png", bg: "bg-[#C6122F]", testid: "securepath" },
  { name: "TRA / TDRA", body: "Telecommunications & Digital Government Regulatory Authority approved", src: "/certs/tdra.svg", bg: "bg-white", testid: "tra" },
  { name: "SIRA", body: "Security Industry Regulatory Agency approved", src: "/certs/sira.svg", bg: "bg-white", testid: "sira" },
];

export const Certifications = () => (
  <section data-testid="certifications-section" className="section relative">
    <div className="wrap">
      <SectionHeading
        eyebrow="Approvals & certifications"
        title="Approved to deliver security and transportation technology in the UAE."
        text="Wexoz holds the regulatory approvals required to design, install and integrate security, surveillance and connected vehicle systems in Dubai and across the UAE."
      />
      <Stagger className="mt-14 grid gap-5 md:grid-cols-3" stagger={0.1}>
        {CERTS.map((c) => (
          <Item key={c.name} data-testid={`certification-${c.testid}`} className="card group flex flex-col overflow-hidden">
            <div className={`flex h-40 items-center justify-center px-10 ${c.bg}`}>
              <img src={c.src} alt={`${c.name} logo`} className="max-h-16 w-auto max-w-full object-contain" loading="lazy" />
            </div>
            <div className="flex flex-1 items-start gap-3 border-t border-line p-6">
              <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-cyan-400" />
              <div>
                <div className="font-heading font-semibold text-white">{c.name}</div>
                <p className="mt-1 text-sm text-slate-400">{c.body}</p>
              </div>
            </div>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
